<template>
  <div class="space-y-32 mb-32">
    <f-box bleed neutral class="md:p-24" v-if="product.onHome">
      <h3 class="antialiased">Finn ut hvor mye du kan låne</h3>
      <p class="mb-32">Ikke sikker på hva du kan kjøpe for? Få hjelp til å regne ut låneevnen din i kalkulatoren vår.</p>
      <f-button href="/okonomi/hvor-mye-kan-jeg-lane">Finn ut hvor mye du kan låne</f-button>
    </f-box>
    <f-box bleed neutral class="md:p-24">
      <h3 class="antialiased">Se hvem som kan tilby deg forsikring</h3>
      <p class="mb-32">Få oversikt over forsikringstilbydere og hva de kan tilby.</p>
      <f-button :href="insuranceLink">Se tilbud på {{ insuranceButtonText }}</f-button>
    </f-box>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'SideProducts',
  props: {
    product: Object
  },
  setup: (props) => {
    const route = useRoute()
    return {
      insuranceButtonText: computed(() => {
        switch (props.product.name) {
          case 'home': return 'boligforsikringer'
          case 'car': return 'bilforsikring'
          case 'motorcycle': return 'MC-forsikring'
          case 'boat': return 'båtforsikring'
        }
      }),
      insuranceLink: computed(() => `/finance/marketplace/insurance/` + route.name)
    }
  }
}
</script>
